import { T, withAlpha } from "../tokens";
import { useState, type ReactNode, type ButtonHTMLAttributes } from "react";

type Variant = "cta" | "teal" | "outline" | "ghost" | "err";
type Size    = "sm" | "md" | "lg";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?:    Size;
  icon?:    ReactNode;
  children: ReactNode;
}

export function Btn({ variant = "cta", size = "md", icon, children, ...rest }: Props) {
  const [h, setH] = useState(false);

  const v = {
    cta:     { bg: h ? T.ctaHov : T.cta,       color: T.ctaTxt, border: "transparent",  shadow: h ? `0 2px 16px ${withAlpha(T.cta, 0.09)}` : "none" },
    teal:    { bg: h ? T.tealDim : T.teal,      color: T.cta,    border: "transparent",  shadow: h ? `0 2px 20px ${withAlpha(T.teal, 0.19)}` : "none" },
    outline: { bg: h ? T.s2 : "transparent",    color: T.t0,     border: T.b2,           shadow: "none" },
    ghost:   { bg: h ? T.s2 : "transparent",    color: h ? T.t0 : T.t1, border: "transparent", shadow: "none" },
    err:     { bg: h ? T.errHov : T.errBg,      color: T.err,    border: T.errBdr,       shadow: "none" },
  }[variant];

  const s = {
    sm: { p: "5px 12px",  fs: "12px", h: "30px" },
    md: { p: "7px 15px",  fs: "13px", h: "34px" },
    lg: { p: "10px 22px", fs: "14px", h: "44px" },
  }[size];

  return (
    <button
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      {...rest}
      style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        background: v.bg, color: v.color, border: `1px solid ${v.border}`,
        borderRadius: "7px", padding: s.p, height: s.h,
        fontSize: s.fs, fontFamily: T.body, fontWeight: 600,
        cursor: "pointer", transition: "all 0.12s ease",
        boxShadow: v.shadow, letterSpacing: "0.01em", whiteSpace: "nowrap",
        ...rest.style,
      }}
    >
      {icon && <span style={{ fontSize: "12px" }}>{icon}</span>}
      {children}
    </button>
  );
}
